import axios from "axios";

// dev
export const apiBe = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_BE_URL}/api/v1/app`,
  timeout: 30_000,
  withCredentials: true,
  headers: {
    "Content-type": "application/json",
    Accept: "application/json",
  },
});

apiBe.interceptors.response.use(
  (response) => response, // 2xx 범위일 때
  (error) => {
    return Promise.reject(error);
  }
);
